import React from "react";
import {
  Chart,
  Series,
  CommonSeriesSettings,
  Label,
  Format,
  Legend,
  Export,
  ValueAxis,
  ConstantLine,
} from "devextreme-react/chart";
import { useNavigate } from "react-router-dom";
import { api_path } from "../../shared.js";
import CustomStore from "devextreme/data/custom_store";
import Box from "@mui/material/Box";

const highAverage = 4;
const lowAverage = 1;

export default function TotalActivityComponent({ userId ,onSelectPoint }) {
  const currentYear = new Date().getFullYear();
  const url = `${api_path}/customer/get-activitySummary.php?userId=${userId}&year=${currentYear}`;

  const dataSource = new CustomStore({
    key: "state",
    load: () =>
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            return data.map((item) => ({
              ...item,
              Telesales: Number(item.Telesales),
              Salesvisit: Number(item.Salesvisit),
              Quotation: Number(item.Quotation),
            }));
          } else {
            console.error("Invalid data:", data);
            return [];
          }
        })
        .catch((err) => {
          console.error("Load error:", err);
          return [];
        }),
  });
 const onPointClick = (e) => {
  const argument = e.target?.argument;
  const seriesName = e.target?.series?.name;
  
  if (onSelectPoint) {
    onSelectPoint({ month: argument, type: seriesName });
  }
};
  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">📊Total Activity</h5>
      <Box sx={{ maxHeight: 500, overflow: "auto" }}>
        <Chart
          id="chart"
          dataSource={dataSource}
          onPointClick={onPointClick}
          height={500}
        >
          <CommonSeriesSettings
            argumentField="state"
            type="bar"
            hoverMode="allArgumentPoints"
            selectionMode="allArgumentPoints"
            valueAxis="activity"
          >
            <Label visible={true}>
              <Format type="fixedPoint" precision={0} />
            </Label>
          </CommonSeriesSettings>
          <ValueAxis name="activity">
            <ConstantLine
              value={highAverage}
              color="red"
              dashStyle="dash"
              label={{ text: `High Avg (${highAverage})`, visible: true }}
            />
            <ConstantLine
              value={lowAverage}
              color="blue"
              dashStyle="dash"
              label={{ text: `Low Avg (${lowAverage})`, visible: true }}
            />
          </ValueAxis>
          {/* แนะนำโทนสีที่ดูชัดเจนและไม่ซ้ำกัน */}
          <Series
            valueField="Telesales"
            name="Telesales"
            color="#17a2b8"
          />{" "}
          {/* เขียว */}
          <Series
            valueField="Salesvisit"
            name="Sales visit"
            color="#40c057"
          />{" "}
          {/* น้ำเงิน */}
          <Series
            valueField="Quotation"
            name="Quotation"
            color="#ff9800"
          />{" "}
          {/* ส้ม */}
          {/* <Series valueField="Telesales" name="Telesales" />
          <Series valueField="Salesvisit" name="Sales visit" />
          <Series valueField="Quotation" name="Quotation" />
          <Series valueField="Negotiate" name="Negotiate" />
          <Series valueField="Close_Won" name="Close(Won)" />
          <Series valueField="Close_Lost" name="Close(Lost)" /> */}
          <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          <Export enabled={true} />
        </Chart>
      </Box>
    </div>
  );
}
